var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-page__container"},[_vm._v(" "+_vm._s(_vm.$capitalize(_vm.$t(_vm.message).toString()))+" "),_vm._t("default"),_c('StaticLink',{attrs:{"path":_vm.$WikiPath.Help,"label":"help"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }